import { StoredGridPresetSchema } from '@/domain/documents/gridPreset/schemas';
import type { StoredGridPreset } from '@/domain/documents/gridPreset/schemas';

// The workspace grid's preset choice and working layout, per user and company, in the app's browser storage.

const storedPresetKey = (userId: string, companyId: string) => `DOKKA_WS_GRID_PRESET:${userId}:${companyId}`;

const parseJson = (raw: string | null): unknown => {
  if (raw == null) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

// An entry that does not parse means Default.
export const readStoredPreset = (storage: Storage, userId: string, companyId: string): StoredGridPreset | null => {
  const parsed = StoredGridPresetSchema.safeParse(parseJson(storage.getItem(storedPresetKey(userId, companyId))));
  return parsed.success ? parsed.data : null;
};

export const writeStoredPreset = (storage: Storage, userId: string, companyId: string, value: StoredGridPreset) =>
  storage.setItem(storedPresetKey(userId, companyId), JSON.stringify(value));
